import { apiClient } from "./NetworkService";
// @ts-ignore
import ApiNames from "../constants/ApiNames";
import type { ApiResponse } from "../types/home";
import type {
  SatCourse,
  SatChapter,
  SatTopic,
  BookmarkTopicRequest,
  BookmarkResponse,
  DeleteBookmarkTopicRequest,
  UnlockTopicRequest,
  UnlockTopicResponse,
} from "../types/satCourse";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getSatCourses = async (subscriberId: string, token?: string): Promise<ApiResponse<SatCourse[]>> => {
  const res = await apiClient.get(`${ApiNames.Satcourses}${subscriberId}`, getHeaders(token));
  return res.data;
};

export const getChapters = async (moduleId: string, subscriberId: string, token?: string): Promise<ApiResponse<SatChapter[]>> => {
  const res = await apiClient.get(`${ApiNames.chapters}${moduleId}&subscriberId=${subscriberId}`, getHeaders(token));
  return res.data;
};

export const getTopics = async (chapterId: string, subscriberId: string, token?: string): Promise<ApiResponse<SatTopic[]>> => {
  const res = await apiClient.get(`${ApiNames.topics}${subscriberId}&chapterId=${chapterId}`, getHeaders(token));
  return res.data;
};

export const bookmarkTopic = async (data: BookmarkTopicRequest, token?: string): Promise<ApiResponse<BookmarkResponse>> => {
  const res = await apiClient.post(ApiNames.bookMark, data, getHeaders(token));
  return res.data;
};

export const getBookmarkedTopics = async (subscriberId: string, token?: string): Promise<ApiResponse<SatTopic[]>> => {
  const res = await apiClient.get(`${ApiNames.BookMark}${subscriberId}`, getHeaders(token));
  return res.data;
};

export const deleteBookmarkTopic = async (data: DeleteBookmarkTopicRequest, token?: string): Promise<ApiResponse<BookmarkResponse>> => {
  const res = await apiClient.post(ApiNames.deletebookmark, data, getHeaders(token));
  return res.data;
};

export const unlockAndGetNextTopic = async (data: UnlockTopicRequest, token?: string): Promise<ApiResponse<UnlockTopicResponse>> => {
  const res = await apiClient.post(ApiNames.unlockNextTopic, data, getHeaders(token));
  return res.data;
};
